import { SCREEN_NAME, CLICK_ACTIONS, SCREEN_VIEW_ACTIONS } from "@payment-client/analytics/constants";
import { AnalyticsContextValue } from "@swiggy-private/analytics";

//CLICK EVENT
export const onDeleteCardClickEvent = (clickEvent: AnalyticsContextValue["clickEvent"]): void => {
    clickEvent({
        category: SCREEN_NAME.PAYMENT_MODES,
        action: CLICK_ACTIONS.CLICK_DELETE_SAVED_CARD,
    });
};

export const onDeleteCardCancelEvent = (clickEvent: AnalyticsContextValue["clickEvent"]): void => {
    clickEvent({
        category: SCREEN_NAME.PAYMENT_MODES,
        action: CLICK_ACTIONS.CLICK_DELETE_HALF_CARD_CANCEL,
    });
};

export const onDeleteCardDismissEvent = (clickEvent: AnalyticsContextValue["clickEvent"]): void => {
    clickEvent({
        category: SCREEN_NAME.PAYMENT_MODES,
        action: CLICK_ACTIONS.CLICK_DISMIISS_DELETE_HALFCARD,
    });
};

//SCREEN CLICK EVENT
export const deleteHalfCardScreenViewEvent = (screenViewEvent: AnalyticsContextValue["screenViewEvent"]): void => {
    screenViewEvent({
        category: SCREEN_NAME.PAYMENT_MODES,
        action: SCREEN_VIEW_ACTIONS.VIEW_DELETE_HALF_CARD,
    });
};

export const deleteCardSuccessScreenViewEvent = (screenViewEvent: AnalyticsContextValue["screenViewEvent"]): void => {
    screenViewEvent({
        category: SCREEN_NAME.PAYMENT_MODES,
        action: SCREEN_VIEW_ACTIONS.VIEW_DELETE_HALF_CARD_SUCCESS,
    });
};
